import { Badge as _Badge, BadgeProps as _BadgeProps } from 'antd'

import { palette } from 'shared/config/styles/palette'

import './Badge.css'

export type BadgeProps = _BadgeProps

interface Props extends BadgeProps {
  value: string | number
}

const Badge = ({ value, className, ...props }: Props) => {
  return (
    <_Badge
      count={value}
      className={`appBadge ${className}`}
      color={palette.red}
      {...props}
    />
  )
}

export default Badge
